import { gql } from '@apollo/client';
import { mutate } from '../../../../../common/graphql/apollo-client';
import { MY_SUBMISSIONS_QUERY } from '../Games/userDeveloperSubmission-graphql';
import { MultiplayerOptions } from '../Submission/GameBaseForm/baseFormHelper';
import { GameLoaderType } from '@crazygames/game-types/src/game-build/loader.type';
import { BUILDS_FRAGMENT } from '../../Admin/Submission/graphql/game-build-graphql';
import { ProgressSaveType } from '@crazygames/game-types/src/game-build/aps.type';
import { FullscreenSetting } from '@crazygames/game-types/src/game-build/fullscreen.type';
import { GameOrientation } from '@crazygames/game-types/src/game-build/orientation.type';
import { UploadedFileInput } from '@crazygames/graph-types/util/uploaded-file-input.type';
import { GameBuild } from '../../Admin/Game/gql/game-build-graphql';

export interface SubmissionAPSDetail {
  progressType: ProgressSaveType;
}

const SUBMIT_GAME_MUTATION = gql`
  mutation createNewGameSubmission($input: DeveloperSubmissionCreateInput!) {
    developerSubmissionCreate(input: $input) {
      id
      slug
      gameBuilds {
        ...GameBuildFragment
      }
    }
  }
  ${BUILDS_FRAGMENT}
`;

export interface SubmitGameMutation {
  developerSubmissionCreate: {
    id: string;
    slug: string;
    gameBuilds: GameBuild[];
  };
}

export interface DeveloperSubmissionCreateInput {
  gameName: string;
  gameFiles: UploadedFileInput[];
  iframeLink?: string;
  fullscreen: FullscreenSetting;
  isIOSFriendly: boolean;
  isAndroidFriendly: boolean;
  orientation: GameOrientation | null;
  gameLoaderType: GameLoaderType;
  unitySaveFileNames?: string[];
  apsDetail: SubmissionAPSDetail;
  hasIAP: boolean;
  isChromebookFriendly: boolean;
  multiplayerOptions?: MultiplayerOptions;
  invitationId?: string;
  gameJamId?: string;
}

const SUBMIT_GAME_MUTATION_INVALIDATIONS = [{ query: MY_SUBMISSIONS_QUERY }];

export function submitGame(input: DeveloperSubmissionCreateInput) {
  return mutate<DeveloperSubmissionCreateInput, SubmitGameMutation>(SUBMIT_GAME_MUTATION, input, {
    refetchQueries: SUBMIT_GAME_MUTATION_INVALIDATIONS,
  });
}
